const BASE_URL = '/api/v1/favorites'

function csrfToken(): string {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta?.getAttribute('content') ?? ''
}

export interface FavoritesData {
  pairingIds: Set<number>
  fontFamilies: Set<string>
}

export const favoritesApi = {
  async load(): Promise<FavoritesData> {
    const res = await fetch(`${BASE_URL}.json`, { credentials: 'same-origin' })
    if (!res.ok) throw new Error(`API error ${res.status}`)
    const data = await res.json()
    return {
      pairingIds: new Set(data.pairing_ids as number[]),
      fontFamilies: new Set(data.font_families as string[]),
    }
  },

  async togglePairing(id: number): Promise<{ favorited: boolean; favoritesCount: number }> {
    const res = await fetch(`${BASE_URL}/pairings/${id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken(),
      },
      credentials: 'same-origin',
    })
    if (!res.ok) throw new Error(`API error ${res.status}`)
    const data = await res.json()
    return { favorited: data.favorited, favoritesCount: data.favorites_count }
  },

  async toggleFont(fontFamily: string): Promise<{ favorited: boolean }> {
    const res = await fetch(`${BASE_URL}/fonts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken(),
      },
      credentials: 'same-origin',
      body: JSON.stringify({ font_family: fontFamily }),
    })
    if (!res.ok) throw new Error(`API error ${res.status}`)
    return await res.json()
  },
}
